document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-primary-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
    });
  }

  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-image]').forEach((button) => {
      button.addEventListener('click', () => {
        const next = button.getAttribute('data-gallery-image');
        const alt = button.getAttribute('data-gallery-alt');
        if (main && next) main.setAttribute('src', next);
        if (main && alt) main.setAttribute('alt', alt);
      });
    });
  });

  document.querySelectorAll('[data-video-loader]').forEach((button) => {
    const frame = button.closest('.tutorial-video');
    const video = frame ? frame.querySelector('[data-lazy-video]') : null;
    const source = video ? video.querySelector('source[data-src]') : null;
    button.addEventListener('click', () => {
      if (source && !source.getAttribute('src')) {
        source.setAttribute('src', source.getAttribute('data-src'));
        video.load();
      }
      button.setAttribute('hidden', '');
      if (video) video.play().catch(() => {});
    });
  });

  const pushEvent = (eventName, payload = {}) => {
    window.dispatchEvent(new CustomEvent(`melonva:${eventName}`, { detail: payload }));
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: `melonva_${eventName}`, ...payload });
    }
  };

  document.querySelectorAll('.newsletter-form').forEach((form) => {
    form.addEventListener('submit', () => {
      const source = form.closest('[data-newsletter-source]');
      pushEvent('newsletter_signup', {
        source: source ? source.getAttribute('data-newsletter-source') : 'newsletter'
      });
    });
  });

  document.querySelectorAll('[data-buy-intent]').forEach((form) => {
    form.addEventListener('submit', () => {
      pushEvent('buy_intent', {
        intent: form.getAttribute('data-buy-intent') || 'buy'
      });
    });
  });

  const popup = document.querySelector('[data-newsletter-popup]');
  if (popup) {
    const storageKey = 'melonvaNewsletterSubmitted';
    const dismissKey = 'melonvaNewsletterDismissed';
    const trigger = document.querySelector('[data-mystery-trigger]');
    const intro = popup.querySelector('[data-mystery-intro]');
    const formStep = popup.querySelector('[data-mystery-form]');
    const reveal = popup.querySelector('[data-mystery-reveal]');
    const storage = {
      get(key = storageKey) {
        try {
          return window.localStorage.getItem(key);
        } catch (error) {
          return null;
        }
      },
      set(key = storageKey) {
        try {
          window.localStorage.setItem(key, 'true');
        } catch (error) {
          return null;
        }
      }
    };
    const successMessage = popup.querySelector('.form-success');
    const showTrigger = () => {
      if (trigger && !storage.get()) trigger.removeAttribute('hidden');
    };
    const hideTrigger = () => {
      if (trigger) trigger.setAttribute('hidden', '');
    };
    const resetPopup = () => {
      if (intro) intro.removeAttribute('hidden');
      if (formStep) formStep.setAttribute('hidden', '');
    };
    const openPopup = (options = {}) => {
      if (storage.get(storageKey) || (!options.manual && storage.get(dismissKey)) || !popup.hasAttribute('hidden')) return;
      popup.removeAttribute('hidden');
      hideTrigger();
    };
    const closePopup = () => {
      popup.setAttribute('hidden', '');
      storage.set(dismissKey);
      showTrigger();
    };

    if (successMessage) {
      if (intro) intro.setAttribute('hidden', '');
      if (formStep) formStep.removeAttribute('hidden');
      popup.removeAttribute('hidden');
      storage.set(storageKey);
      hideTrigger();
    }

    popup.querySelectorAll('[data-newsletter-close]').forEach((control) => {
      control.addEventListener('click', closePopup);
    });

    if (reveal && formStep) {
      reveal.addEventListener('click', () => {
        if (intro) intro.setAttribute('hidden', '');
        formStep.removeAttribute('hidden');
        const email = formStep.querySelector('input[type="email"]');
        if (email) email.focus();
        pushEvent('mystery_offer_reveal');
      });
    }

    if (trigger) {
      trigger.addEventListener('click', () => {
        resetPopup();
        openPopup({ manual: true });
        pushEvent('mystery_offer_trigger');
      });
    }

    popup.querySelectorAll('form').forEach((form) => {
      form.addEventListener('submit', () => {
        storage.set(storageKey);
        hideTrigger();
      });
    });

    window.setTimeout(openPopup, 12000);
    window.setTimeout(showTrigger, 4500);
    document.addEventListener('mouseleave', (event) => {
      if (event.clientY <= 0) openPopup();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !popup.hasAttribute('hidden')) closePopup();
    });
  }
});
